import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import xiaoyuzhou from "@/assets/agent/xiaoyuzhou.webp";

export const XiaoYuZhouImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[xiaoyuzhou]}
      {...props}
    />
  );
};

XiaoYuZhouImage.displayName = 'XiaoYuZhouImage';
